// import realestate_workflow from '../../images/prediction workflow.png' 
import realestate_workflow from '../../../images/prediction workflow.png' 
import attention_all_you_need from '../../../images/Attention all you need-Model.jpg' 
import candlestick from '../../../images/candlestick.jpeg' 




export const data = [
    {
      id: 1,
      title: "Building a MERN Stack Real Estate Machine Learning App: A Comprehensive Guide",
      desc: "The real estate market is constantly evolving, requiring accurate predictions and recommendations for informed decision-making. As an aspiring data scientist and full-stack developer, I built a MERN Stack Real Estate Machine Learning App to leverage prediction, analysis, and recommendations for better market insights.",
      image: realestate_workflow,
      link: "https://medium.com/@dipanjanpathak/building-a-mern-stack-real-estate-machine-learning-app-a-comprehensive-guide-ef680f49e6da"
    },
    {
      id: 2,
      title: "Decoding Multi-Head Attention: A Key Component of the ‘Attention Is All You Need’ Architecture",
      desc: "In 2017, Vaswani et al. introduced the Transformer model, revolutionizing NLP with models like BERT and GPT. This blog simplifies the core components of the Transformer architecture, making it easy for beginners and AI enthusiasts to understand its power and functionality.",
      image: attention_all_you_need,
      link: "https://medium.com/@dipanjanpathak/decoding-the-transformer-a-visual-guide-to-the-attention-is-all-you-need-architecture-5ae390c833a0"
    },
    {
      id: 3,
      title: "Financial Qestions and Answers",
      desc: "This collection of financial questions and answers centers on options trading, with a focus on volatility. It explores how volatility—both implied and historical—affects option pricing, trading strategies, and decision-making. The content offers useful insights for understanding the crucial role volatility plays in the options market.",
      image: candlestick,
      link: "/blog/finance_Q&A"
    }
  ];
  